import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@flex-design-system/fx';
import { styled } from '@flex-design-system/stitches-react';
import { forwardRef } from 'react';
import { useFileUploadContext } from '../context.mjs';

const FileUploadDropOverlay = forwardRef((props, forwardedRef) => {
  const { dragging } = useFileUploadContext("FileUpload.DropOverlay");
  return /* @__PURE__ */ jsx(
    DropOverlayRoot,
    {
      "data-part": "drop-overlay",
      visible: dragging,
      "aria-hidden": !dragging,
      ref: forwardedRef,
      ...props
    }
  );
});
const DropOverlayRoot = styled(Primitive.div, {
  size: "100%",
  position: "absolute",
  inset: 0,
  backgroundColor: "rgba(230, 241, 250, 0.77)",
  backdropFilter: "blur(4.5px)",
  outline: "1px dashed $cosmicBlue",
  variants: {
    visible: {
      true: { visibility: "visible" },
      false: { visibility: "hidden" }
    }
  }
});

export { FileUploadDropOverlay };
//# sourceMappingURL=DropOverlay.mjs.map
